import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { DoiTraHang, DoiTraHangCt } from '../kd-doi-tra-hang-model/kd-doi-tra-hang.model';
import { DoiTraHangService } from '../kd-doi-tra-hang-service/kd-doi-tra-hang.service';
import { DeNghiNhapKhoAddEditComponent } from '../../../chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-add-edit-page/kho-de-nghi-nhap-kho-add-edit-page.component';

@Component({
	selector: 'm-kd-doi-tra-hang-detail',
	templateUrl: './kd-doi-tra-hang-detail.component.html',
	styleUrls: ['../kd-doi-tra-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class DoiTraHangDetailComponent implements OnInit {

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport: ElementRef;
	@ViewChildren('focusDetail') focusDetail;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 0,
			name: 'select',
			displayName: '',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaKH',
			displayName: 'Mã khách hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenKH',
			displayName: 'Tên khách hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DonViTinh',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'SoLo',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'HanSuDung',
			displayName: 'Hạn sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SoLuongDoi',
			displayName: 'Số lượng đổi',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'GiaBan',
			displayName: 'Giá bán',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'ThanhTien',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'HuongXuLy',
			displayName: 'Hướng xử lý',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHHKemTheo',
			displayName: 'Mã hàng kèm theo',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHHKemTheo',
			displayName: 'Tên hàng kèm theo',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SoLuongDeXuat',
			displayName: 'Số lượng đề xuất',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'ThamChieu',
			displayName: 'Tham chiếu',
			alwaysChecked: false,
			isShow: true
		},
		
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách khách hàng-----------------------*/
	listKH: any[] = [];
	selectListKH: string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */

	/*------------------------ Danh sách ĐVT -----------------------------*/
	listDVT: any[] = [];
	selectListDVT: string = '';
	filteredListDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListDVTFilterCtrl: string = '';
	haveElementListDVT: boolean = false;
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DoiTraHangCt>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	MasterForm: FormGroup;
	HHForm: FormGroup;
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	item: DoiTraHang;
	listChiTiet: DoiTraHangCt[] = [];
	tmpChiTiet: DoiTraHangCt[] = [];
	flagArray: any[] = [];
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	openTimKiemNangCao = false;
	textQuiDoiDVT = '';
	showButtonDG: boolean = false;
	isFromDNNK: boolean = false;
	FormDuyet: FormGroup;
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<DoiTraHangDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private services: DoiTraHangService,
		private dungChungService: DungChungService,
		private MasterFB: FormBuilder,
		private HHFB: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private FormDuyetFB: FormBuilder,
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load all dropdown and create form */
		this.ListKH();
		this.ListState();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.item = this.data.data;
		this.showButtonDG = this.data.isDuyet
		this.isFromDNNK = this.data.isFromDNNK
		this.title = this.getTitle();
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape" && !this.openTimKiemNangCao) {
				this.back();
			}
			this.changeDetectView();
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.item.NguoiTao = +idUser;

		/*Group các Form */
		this.MasterForm = this.MasterFB.group({
			SoPhieu: [this.item.SoPhieu],
			NgayLapPhieu: [this.item.NgayTao],
			TenNguoiLap: [this.item.TenNguoiTao],
			TrangThai: [this.nameState],
		});
		/*Disable các trường dữ liệu không thay đổi */
		this.MasterForm.disable();

		/*------------------------------------------------------------------*/
		this.FormDuyet = this.FormDuyetFB.group({
			NGUOIDUYET: [this.item.NguoiDuyet ? this.item.NguoiDuyet : "", Validators.required],
			NGAYDUYET: [this.item.NgayDuyet ? this.item.NgayDuyet : "", Validators.required],
			TINHTRANG: [this.item.TinhTrang ? this.item.TenTinhTrang : ''],
			GHICHU: [this.item.LyDoDuyet ? this.item.LyDoDuyet : '', Validators.required],
			GiaoBu: [this.item.GiaoBu, Validators.required],

		});
		this.FormDuyet.controls['NGUOIDUYET'].disable();
		this.FormDuyet.controls['NGAYDUYET'].disable();
		this.FormDuyet.controls['TINHTRANG'].disable();
		if(!this.showButtonDG){
			
			this.FormDuyet.controls['GHICHU'].disable();
			this.FormDuyet.controls['GiaoBu'].disable();
		}
		/*Add dữ liệu chi tiết*/
		if (this.item.listDetail.length > 0) {
			this.listChiTiet = this.item.listDetail;
			this.tmpChiTiet = [];
			for (let i = 0; i < this.listChiTiet.length; i++) {
				let tmpElement = new DoiTraHangCt();
				tmpElement.copy(this.listChiTiet[i])
				this.tmpChiTiet.push(tmpElement);
			}
			this.tmpChiTiet = [...this.tmpChiTiet];
		}
		this.changeDetectView();
	}
	getTitle(): string {
		if(this.showButtonDG){
			return 'Duyệt đổi trả hàng';
		}
		return 'Chi tiết đổi trả hàng';
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		if (this.item.TinhTrang == DoiTraHang.optionsTinhTrang[4].value) {
			this.availableColumns.push({
				stt: 10,
				name: 'actions',
				displayName: 'Thao tác',
				alwaysChecked: false,
				isShow: true
			})
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		let _selectedColumns = this.selectedColumns.selected;
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/

	Duyet(isDuyet: boolean) {
		// Set status based on approval decision
		if (isDuyet) {
			this.item.TinhTrang = DoiTraHang.optionsTinhTrang[3].value; // Approved status
		} else {
			this.item.TinhTrang = DoiTraHang.optionsTinhTrang[2].value; // Rejected status
		}

		// Get form values
		this.item.NguoiDuyet = this.FormDuyet.get('NGUOIDUYET').value;
		this.item.NgayDuyet = this.FormDuyet.get('NGAYDUYET').value;
		this.item.LyDoDuyet = this.FormDuyet.get('GHICHU').value;
		this.item.GiaoBu = this.FormDuyet.get('GiaoBu').value;
		// Call API to confirm status change
		this.loadingSubject.next(true);
		this.services.DoiTraHang_Confirm(this.item).subscribe(
			res => {
				this.loadingSubject.next(false);
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(
						isDuyet ? 'Duyệt thành công' : 'Từ chối thành công'
					);
					this.dialogRef.close({
						isChange: true, 
						status: isDuyet
					});
				} else {
					this.layoutUtilsService.showErorr('Có lỗi xảy ra');
				}
				this.changeDetectView();
			},
			error => {
				this.loadingSubject.next(false);
				this.layoutUtilsService.showErorr('Có lỗi xảy ra');
			}
		);
	}
	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState() {
		this.dungChungService.listState(DoiTraHang.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.item.TinhTrang) {
				this.nameState = element.Description;
				if (this.MasterForm != null)
					this.MasterForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListId_HH() {
		this.dungChungService.layDanhSachHangHoaTheoLoai(DoiTraHang.thanhPhamId).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}

	ListKH() {
		this.dungChungService.listKH().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKH = res.data;
				this.filteredListKH.next(this.listKH.slice());
				this.changeDetectView();
			};
		});
	}
	filterListKH() {
		if (!this.listKH) {
			return;
		}
		let search = this.ListKHFilterCtrl;
		if (!search) {
			this.filteredListKH.next(this.listKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListKH.next(
			this.listKH.filter(ts =>
				(ts.MaKH + ' - ' + ts.TenKH).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView()
	}
	getNameKH() {
		let name = '';
		if (this.listKH.length > 0) {
			var item = this.listKH.filter(x => x.Id_KH == +this.MasterForm.controls['MaKH'].value);
			if (item.length > 0) name = item[0].MaKH;
		}
		return name ? name : '';
	}

	ListDVT() {
		this.dungChungService.getDSDonViTinh().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT = res.data;
				this.filteredListDVT.next(this.listDVT.slice());
				this.changeDetectView()
			};
		});
	}
	changeDVT() {
		if (!this.HHForm.controls["SanPhamMoi"].value) {
			this.listId_HH.forEach(element => {
				if (element.IdHH == +this.selectId_HH) {
					var listDVTHH = []
					listDVTHH.push(element.DVT);
					if (element.Dvt2 != null && element.Dvt2 > 0)
						listDVTHH.push(element.Dvt2);
					if (element.Dvt3 != null && element.Dvt3 > 0)
						listDVTHH.push(element.Dvt3);

					let currentDVT = listDVTHH.findIndex(x => x == +this.HHForm.controls["DVT"].value)
					if (currentDVT == 1) {
						var numQuiDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))
							* Number(element.QuiDoiDVT2)
						if (numQuiDoi > 0)
							this.textQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT
					}
					else if (currentDVT == 2) {
						var numQuiDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))
							* Number(element.QuiDoiDVT3)
						if (numQuiDoi > 0)
							this.textQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT
					}
					else if (currentDVT == 0) {
						this.textQuiDoiDVT = '';
					}
				}
			});
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DoiTraHangCt.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	getThoiGianGiuGia(item:any){
		if(item.ThoiGianDuyet == null){
			return ''
		}
		let endDate = new Date(new Date(item.ThoiGianDuyet).getTime() + item.ThoiHanGiuGia * 24 * 60 * 60 * 1000)
		return 'Từ ' + this.getFormatDate(item.ThoiGianDuyet) + ' - Đến ' + this.getFormatDate(endDate.toISOString());
	}
	checkThoiGianGiuGia(item:any){
		if(item.ThoiGianDuyet == null){
			return false;
		}
		if(this.data.data.isShowFromDuyetGia != undefined){
			return false;
		}
		let endDate = new Date(new Date(item.ThoiGianDuyet).getTime() + item.ThoiHanGiuGia * 24 * 60 * 60 * 1000);
		return new Date() <= endDate;
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DoiTraHangCt) {

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.f_number(event.target.value.toString());

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		this.dialogRef.close(
			{
				isChange: this.isChange,
				dataAdd: this.saveAdded,
			}
		);
	}
	
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/
	//Logic of select all check box
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpChiTiet.length;
		return numSelected === numRows;
	}
	masterToggle() {
		this.isAllSelected() ?
			this.selection.clear() :
			this.tmpChiTiet.forEach(row => this.selection.select(row));
	}
	checkboxLabel(row?: DoiTraHangCt): string {
		if (!row) {
			return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
		}
		return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row}`;
	}
	//TaoDNNK
	TaoDNNK(){
		//Check if all the selection is same MaKH
		let MaKH = this.tmpChiTiet[0].MaKH;
		let check = this.tmpChiTiet.every(x => x.MaKH == MaKH);
		if(!check){
			this.layoutUtilsService.showErorr('Chỉ chọn các dòng cùng mã khách hàng cho mỗi phiếu ĐNNK');
			return;
		}
		//Open component DeNghiNhapKhoAddEditComponent as dialog
		const dialogRef = this.dialog.open(DeNghiNhapKhoAddEditComponent, {
			data: {
				data: this.selection.selected,
				type: 'DoiTraHang',
			}
		});
		dialogRef.afterClosed().subscribe(res => {
			this.services.getDetail(this.data).subscribe(res => {
				if (res.status == 1) {
					this.tmpChiTiet = res.data.listDetail;
				}
			})
		});
		
	}
	//Detail tham chieu open new tab of DeNghiNhapKho
	DetailThamChieu(row: any) {
		const thamChieuNumber = row.ThamChieu.replace(/\D/g, '');
		window.open(`de-nghi-nhap-kho/chi-tiet/${thamChieuNumber}`, '_blank');
	}
	disableMasterToggle(){
		return this.tmpChiTiet.every(item => item.ThamChieu != null);
	}
	/*----------------------------- Thao tác trên list ------------------------*/
	

}